import { Box, useColorModeValue } from "@chakra-ui/react";
import React, { useState } from "react";

function SignupSteps({ index, children }) {
  const [current, setCurrent] = useState(index || 0);
  const textColor = useColorModeValue("#fff", "#fff");

  const next = () => {
    const nextValue = current + 1 + 1;

    if (nextValue > children?.length) return;
    setCurrent((prev) => prev + 1);
  };

  return (
    <Box>
      {React.Children.map(children[current], (child, index) =>
        React.cloneElement(child, {
          id: index,
          next,
        })
      )}
    </Box>
  );
}

export default SignupSteps;
